"use client";

import { ReactNode, useContext, useEffect } from "react";
import { UserContext } from "@/contexts/user-context";

export const RedirectLoggedOutUsers = ({
  children,
}: {
  children: ReactNode;
}) => {
  const { isLoggedIn } = useContext(UserContext);
  useEffect(() => {
    if (!isLoggedIn) {
      location.href = "/login";
    }
  }, []);

  return isLoggedIn ? <>{children}</> : null;
};
